import React from 'react';
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DetailsPanel = ({
    heading,
    fields = [],
    showCloseIcon = true,
    onClose,
    headerContent = null,
    extraContent = null,
    containerClassName = "subscription-details-container",
}) => (
    <div className={containerClassName}>
        <div
            className="plan-details-header-container"
            style={!headerContent ? { justifyContent: 'flex-end', padding: "0" } : undefined}
        >
            {headerContent}
            {showCloseIcon && (
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            )}
        </div>
        <div className="plan-details">
            <p className="plan-details-heading"> {heading}</p>
            <div className="plan-content">
                {extraContent}
                {fields.map((field, idx) => (
                    <div className="plan-fields" key={idx}>
                        <p className="plan-field-label">{field.label}:</p>
                        <p className="plan-field-value">{field.value ?? "-"}</p>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default DetailsPanel;